module.exports = __webpack_public_path__ + "img/pvc_900g_farbauswahl_komplett.592f4db0.jpg";